import { PillSlot } from 'types/markerTypesV2/m-v2-core.js';
import { MarkerTag } from 'types/markerTypesV2/marker-tags.js';
import { getDotSlotIndex } from './get-dot-slot-index.js';

export const resolveDotSlotIndex = (slots: readonly PillSlot[], tags?: readonly string[]): number => {
  if (tags?.includes(MarkerTag.DotSlotBbq)) {
    const i = slots.findIndex((s) => s.icon === 'bbq');
    return i >= 0 ? i : 0;
  }
  if (tags?.includes(MarkerTag.DotWorstSlot)) {
    return getDotSlotIndex(slots);
  }
  return 0;
};
